import { PlusInSquareIcon } from "assets/icons";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Pagination, SearchInput, Switch } from "ui";

import {
  ChangeInventoryManagerDeleteModal,
  InventoryManagerModal,
  InventoryManagersTable
} from "../../components";
import { useInventoryManagersList } from "../../hooks";
import { InventoryManagerListItem } from "../../inventory.types";

import styles from "./Managers.module.scss";

const Managers = () => {
  const {
    inventoryManagersList,
    isLoading,
    page,
    searchValue,
    totalItems,
    sorting,
    showDeletedOnly,
    setShowDeletedOnly,
    setSorting,
    setSearchValue,
    setPage,
    refetchInventoryManagers
  } = useInventoryManagersList();
  const [changingDeleteStatusManager, setChangingDeleteStatusManager] =
    useState<InventoryManagerListItem | null>(null);
  const [editableManager, setEditableManager] =
    useState<InventoryManagerListItem | null>(null);
  const {
    value: isManagerModalOpen,
    setTrue: onOpenModal,
    setFalse: onCloseModal
  } = useBoolean(false);

  const handleCloseModalClick = () => {
    onCloseModal();
    setEditableManager(null);
  };

  useEffect(() => {
    if (editableManager) {
      onOpenModal();
    } else {
      onCloseModal();
    }
  }, [editableManager, onOpenModal, onCloseModal]);

  return (
    <div className={styles.managers}>
      <div className={styles.managers_headerControls}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={`${t("Search")}...`}
        />

        <Switch
          label={t("Deleted Only")}
          checked={showDeletedOnly}
          onChange={(e) => setShowDeletedOnly(e.target.checked)}
        />

        <Button
          title={t("Add New Manager")}
          icon={<PlusInSquareIcon />}
          onClick={onOpenModal}
        />
      </div>

      <div className={styles.managers_tableContainer}>
        <InventoryManagersTable
          managers={inventoryManagersList ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          refetchInventoryManagers={refetchInventoryManagers}
          onChangeDeleteStatus={setChangingDeleteStatusManager}
          onEditManager={setEditableManager}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
        totalItems={totalItems}
      />

      <InventoryManagerModal
        editableManager={editableManager}
        isOpen={isManagerModalOpen}
        onClose={handleCloseModalClick}
        refetchManagers={refetchInventoryManagers}
      />

      <ChangeInventoryManagerDeleteModal
        id={String(changingDeleteStatusManager?.id)}
        isOpen={Boolean(changingDeleteStatusManager)}
        action={changingDeleteStatusManager?.isDeleted ? "Restore" : "Delete"}
        onClose={() => setChangingDeleteStatusManager(null)}
      />
    </div>
  );
};

export default Managers;
